module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/intro-055b4e03532590c56a67748a9ad67c54.jpg";